import Class from './c-content-chart-stack-column';
import './c-content-chart-stack-column@.vue';

export default Class;